exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._1b1t__L0Wjlm-OLPzn2LGO{padding:0 16px}._3ZfP40sBeGPSZU-woAlnDU{font-size:14px;font-weight:400;color:\"[theme:themeDarkAlt, default:#005A9E]\";height:48px;overflow:hidden}html[dir] ._3ZfP40sBeGPSZU-woAlnDU{padding:0}html[dir=ltr] ._3ZfP40sBeGPSZU-woAlnDU{float:right}html[dir=rtl] ._3ZfP40sBeGPSZU-woAlnDU{float:left}._3ZfP40sBeGPSZU-woAlnDU:active,._3ZfP40sBeGPSZU-woAlnDU:hover{color:\"[theme:themeDarkAlt, default:#005A9E]\"}", ""]);

// exports
exports.locals = {
	"wrapper": "_1b1t__L0Wjlm-OLPzn2LGO",
	"linkButton": "_3ZfP40sBeGPSZU-woAlnDU"
};